<template>
    <div>
        <div class="mainTop cf">
            <navZcy v-bind:num="3"></navZcy>
            <management></management>
        </div>

        <div class="aside">
            <el-tabs :tab-position="leftTab" style="height: 1500px;" @tab-click="tagEvent" v-model="activeName">
                <el-tab-pane label="机台管理" name="machineinfo"></el-tab-pane>
                <el-tab-pane label="在线机台" name="machineonline"></el-tab-pane>
                <el-tab-pane label="Carsh信息" name="carsh"></el-tab-pane>
            </el-tabs>
        </div>

        <el-col :span="21">
            <div style="margin-left: 10px;margin-top: 10px;">
                <div style="margin-bottom: 10px;">
                    <a>工作台</a>
                </div>

                <el-tabs v-model="editableTabsValue" type="card" closable   @tab-remove="removeTab">
                    <el-tab-pane
                            v-for="(item) in tabData"
                            :key="item.id"
                            :name="item.name"
                            :label="item.label"
                    >
                        <component v-bind:is="item.cmpname"></component>

                    </el-tab-pane>
                </el-tabs>
            </div>
        </el-col>
    </div>
</template>

<script>
    import management from './management.vue'
    import navZcy from './nav.vue'
    import machineinfo from'./machineinfo'
    import carsh from'./carsh'

    export default {
        name: "machineManager",
        components:{
            management,
            navZcy,
            machineinfo,
            carsh,
        },
        data() {
            return {
                leftTab: 'left',
                activeName: '',
                editableTabsValue:'',
                tabIndex:0,
                tabData:[],
                componentMap: {
                    machineinfo: {
                        name: '机台管理',
                        single: true,
                    },
                    carsh:{
                        name:'Carsh信息',
                        single:true,
                    }
                    /*machineonline: {
                        name: '在线机台',
                        single: true
                    },*/
                }
            }
        },
        methods: {
            tagEvent(tag) {
                if (tag.name=='machineonline'){
                    console.log("window.location.href :",window.location.href)
                    window.location.href = this.getVueUrlMainPath()+'/operation'
                    //window.location.href = '/operation'

                    return
                }
                var createNew = true
                var existNodeName = ''
                if (this.componentMap[tag.name].single) {
                    for (let i = 0; i < this.tabData.length; i++) {
                        if (this.tabData[i].cmpname == tag.name) {
                            existNodeName = this.tabData[i].name
                            createNew = false
                            break
                        }
                    }
                }
                if (createNew) {
                    let newName = tag.name + this.tabIndex
                    let obj = {
                        name: newName,
                        label: this.componentMap[tag.name].single ? this.componentMap[tag.name].name : this.componentMap[tag.name].name + this.tabIndex,
                        cmpname: tag.name,
                        id: this.tabIndex
                    }
                    console.log(obj)
                    this.tabData.unshift(obj)
                    this.tabIndex = this.tabIndex + 1
                    this.editableTabsValue = newName
                } else {
                    this.editableTabsValue = existNodeName
                }
            },
             getVueUrlMainPath() {
                 var path = window.location.href
                 path = path.substring(0, path.indexOf("#"))
                 path = path.substring(0, path.lastIndexOf("/"))
                 return path
             },
            removeTab(targetName) {
                for (let i = 0; i < this.tabData.length; i++) {
                    if (this.tabData[i].name == targetName) {
                        this.tabData.splice(i, 1)
                        break
                    }
                }
            },
        }
    }
</script>

<style scoped>
    .aside{
        width: 11%;
        float: left;
    }
</style>
